import io from "socket.io-client";

export const socket = io(process.env.REACT_APP_BACKEND_URI, {
  withCredentials: true, // Ensure credentials are included if needed
}); // Connect to your Socket.IO server
